/**
 * @file Simple email registration form container.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Alert from '../global/Alert';
import FormGroup from '../global/FormGroup';
import Button from '../global/Button';

class EmailRegisterForm extends Component {
  static propTypes = {
    error: PropTypes.string,
    loading: PropTypes.bool,
    register: PropTypes.func.isRequired,
    onRegister: PropTypes.func,
  };

  state = {
    email: '',
    password: '',
    passwordConfirm: '',
    error: '',
  };

  onInputChange = event => {
    const { name, value } = event.target;

    this.setState(() => ({ [name]: value }));
  };

  onFormSubmit = event => {
    event.preventDefault();
    const { email, password, passwordConfirm } = this.state;
    const { register, onRegister } = this.props;

    this.setState(() => ({ error: '' }));

    if (password !== passwordConfirm) {
      this.setState(() => ({ error: 'Passwords do not match.' }));
      return;
    }

    register(email, password);

    if (onRegister) {
      onRegister();
    }
  };

  render() {
    const { email, password, passwordConfirm, error: formError } = this.state;
    const { loading, error } = this.props;

    return (
      <form
        method="post"
        className="form-email-register"
        onSubmit={this.onFormSubmit}
      >
        {(formError || error) && (
          <Alert type="danger">{formError || error}</Alert>
        )}

        <FormGroup
          id="register-email"
          type="email"
          label="Your email"
          name="email"
          required
          value={email}
          onChange={this.onInputChange}
        />

        <FormGroup
          id="register-password"
          type="password"
          label="Password"
          name="password"
          required
          value={password}
          onChange={this.onInputChange}
        />

        <FormGroup
          id="register-password-confirm"
          type="password"
          label="Confirm your password"
          name="passwordConfirm"
          required
          value={passwordConfirm}
          onChange={this.onInputChange}
        />

        <Button type="submit" disabled={loading} className="mt-0">
          {loading ? 'Please wait…' : 'Register'}
        </Button>
      </form>
    );
  }
}

export default EmailRegisterForm;
